export default function init() { return Promise.resolve(); }
export function process_content(s) { return s; }
